/* unplugin-vue-components disabled */import { render } from "./reasoning-item.vue?vue&type=template&id=ac7af27c&scoped=true"
import script from "./reasoning-item.vue?vue&type=script&lang=js"
export * from "./reasoning-item.vue?vue&type=script&lang=js"

import "./reasoning-item.vue?vue&type=style&index=0&id=ac7af27c&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7af27c"],['__file',"src/components/ai-chat/ai-assistant/research/reasoning-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac7af27c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac7af27c', __exports__)) {
    api.reload('ac7af27c', __exports__)
  }
  
  module.hot.accept("./reasoning-item.vue?vue&type=template&id=ac7af27c&scoped=true", () => {
    api.rerender('ac7af27c', render)
  })

}


export default __exports__